import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { DEFAULT_SIGNING_MUTATION_PARAMS } from "@/modules/patients/detail/conclude/services/useDocumentSigning"
import {
  Ch_signPrescriptionDocumentInput,
  useChSignPrescriptionMutation as useChSignPrescriptionMutationType,
} from "@/modules/patients/detail/therapy-prescription/ch/services/__generated__/useChSignPrescriptionMutation.graphql"

const mutation = graphql`
  mutation useChSignPrescriptionMutation($input: Ch_signPrescriptionDocumentInput!) {
    ch_signPrescriptionDocument(input: $input) {
      ch_Prescription {
        id
        createdAt
        createdBy
        signedBy
        signedAt
        updatedAt
        updatedBy
        fileId
        ...chPrescriptionFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

type Config = Omit<UseMutationConfig<useChSignPrescriptionMutationType>, "variables"> & {
  id: Ch_signPrescriptionDocumentInput["id"]
  progressNoteId: string
}

const useChSignPrescriptionMutation = () => {
  const [commit, isFlight] = useMutationWithErrorDialog<useChSignPrescriptionMutationType>(
    mutation,
    DEFAULT_SIGNING_MUTATION_PARAMS,
  )

  const commitHandler = useCallback(
    async (config: Config) => {
      commit({
        variables: {
          input: {
            id: config.id,
          },
        },
        ...config,
      })
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChSignPrescriptionMutation }
